export default __webpack_public_path__ + "static/media/usermar2.6d42d038.svg";